// store/slices/resetSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isReset: false
};

const resetSlice = createSlice({
    name: 'reset',
    initialState,
    reducers: {
        setResetTrue: (state) => {
            state.isReset = true;
        },
        setResetFalse: (state) => {
            state.isReset = false;
        }
    }
});

export const { setResetTrue, setResetFalse } = resetSlice.actions;
export default resetSlice.reducer;
